export const TYPES_STATUS_ALERT_MESSAGE = {
    "-3": {
        id: -3,
        value: "Onboarding",
        alert: {
            header: "Ce statut a pour conséquences sur le collaborateur :",
            list: [
                "Il aura accès à l'ensemble de l'outil et sera inclus dans l'organigramme",
            ],
        },
    },
    6: {
        id: 6,
        value: "Offboarding",
        alert: {
            header: "Ce statut a pour conséquences sur le collaborateur :",
            list: [
                "Il aura accès à l'ensemble de l'outil et sera inclus dans l'organigramme",
            ],
        },
    },
    5: {
        id: 5,
        value: "Archivé",
        alert: {
            header: "Ce statut a pour conséquences sur le collaborateur :",
            list: [
                "Plus de connexion possible à Yeetch",
                "Archivage de la liste de tâches",
                "Réinitialisation de tous les soldes (vacances, récupération, congés payés...)",
                "Il ne sera plus visible dans l'outil",
            ],
        },
    },
    1: {
        id: 1,
        value: "Suivi",
        alert: {
            header: "Ce statut a pour conséquences sur le collaborateur :",
            list: [
                "Il aura accès à l'ensemble de l'outil et sera inclus dans l'organigramme",
            ],
        },
    },
};
